export default __webpack_public_path__ + "static/Museo-Sans-500-e8d3661f138aafdf6aaf1cf1db046dee.woff2";